import styles from './processing-status.module.css';
import { Text } from '@SBGSports/catapult-core';
import { CellAvatarComponent } from 'reporting/components/cell-editable/cell-avatar';
import { useTranslations } from 'i18n';
import { ActivityAthlete } from 'oas';

type AthleteCellProps = {
    athlete: ActivityAthlete;
    className: string;
};

export const AthleteCell: React.FC<AthleteCellProps> = (props) => {
    const { athlete, className } = props;
    const { __ } = useTranslations();
    const deviceId = athlete.device_info?.device_id;
    return (
        <div className={className}>
            <div className={styles['athlete-cell-inner']}>
                <CellAvatarComponent
                    avatarSrc={athlete.image ?? ''}
                    firstInitial={athlete.first_name?.[0]}
                    secondInitial={athlete.last_name?.[0]}
                />
                <div>
                    <Text variant="title-small" className="text-system-primary">
                        {athlete.first_name} {athlete.last_name}
                    </Text>
                    {/* Boolean will exclude both undefined and 0 (which may be used by backend) */}
                    {Boolean(deviceId) && (
                        <Text variant="body-small" className="text-system-on-surface-variant">
                            {__('misc.device_id')}: {deviceId?.toString()}
                        </Text>
                    )}
                </div>
            </div>
        </div>
    );
};

type AthletesGridProps = {
    label: string;
    athletes: ActivityAthlete[];
    searchString?: string;
};

export const AthletesGrid: React.FC<AthletesGridProps> = (props) => {
    const { athletes, searchString } = props;
    const lowSearchString = searchString?.trim().toLowerCase() ?? '';

    const filteredAthletes = athletes?.filter((a) => {
        if (!lowSearchString) {
            return true;
        }

        const searchableValues = [a.first_name, a.last_name, a.jersey, a.device_info?.device_id?.toString()];
        // check if any searchable value includes the lowercase search term
        return searchableValues.some((value) => value?.toLowerCase().includes(lowSearchString));
    });
    return (
        <div className={styles['athletes-grid-column']}>
            <div className={styles['athletes-grid']}>
                {filteredAthletes?.map((a, i) => {
                    const totalRows = Math.ceil(filteredAthletes.length / 3);
                    const currentRow = Math.floor(i / 3) + 1;
                    const isLastRow = currentRow === totalRows;
                    return (
                        <AthleteCell
                            key={a.id}
                            athlete={a}
                            className={`${styles['athlete-cell']} ${isLastRow ? styles['no-border'] : ''}`}
                        />
                    );
                })}
            </div>
        </div>
    );
};
